import SENSITIVE_CONTENT from "@/view/constants/sensitiveContent";

const findSensitiveContentTag = (tags) => {
  return tags.find((tag) => tag?.data?.name === SENSITIVE_CONTENT);
};

export default findSensitiveContentTag;
